import React, {useState} from "react";
import axios from 'axios';
import {API_URL} from "../../../utils/Common";
import {ToastsContainer, ToastsContainerPosition, ToastsStore} from "react-toasts";

import HeadRegresar from "../../sharecomponents/HeadRegresar";
import MyLoader from "../../sharecomponents/MyLoader";
import CantPorVariedad from "./CantPorVariedad";
import CantPorColor from "./CantPorColor";

const PorcentajesPlan = (props) => {
    const florId = props.match.params.id; // -- el ID de la flor
    const flor = props.match.params.flor;
    const year = props.match.params.year;

    const [loader, updateLoader] = useState(false);
    const [semana, setSemana] = useState({ semana: '0'});
    const [variedades, setVariedades] = useState([]);
    const [variedad, setVariedad] = useState('(No Seleccionada)');
    const [colores, setColores] = useState([]);

    const onChange = (e) => {
        console.log(e.target.value)
        getData(e.target.value);
        setSemana({
            ...semana,
            [e.target.name]: e.target.value,
        });
    }

    const getData = (semana) => {
        updateLoader(true);
        axios.get(API_URL + '/getpordata', {params: {semana, florId, year }})
            .then(r => {
                console.log(r.data);
                setVariedades(r.data.variedades);
                updateLoader(false);
            }).catch(e => console.log(e));
    }

    const getColores = (variedad) => {
        setVariedad(variedad.nombre);

        let cantVariedad = (variedad.porcentaje / 100) * variedad.totalPlan;
        updateLoader(true);
        axios.get(API_URL + '/getporcolores', {params: {s: semana.semana, varId: variedad.id, florId, cantVariedad }})
            .then(r => {
                console.log(r.data);
                setColores(r.data.colores);
                updateLoader(false);
                if (r.data.colores.length === 0) {
                    ToastsStore.error('No hay colores definidos a la variedad seleccioanda!');
                }
            }).catch(e => console.log(e));
    }

    const updateVariedad = (cantidad, index) => {
        variedades[index].cantidadFlor = (cantidad/100) * variedades[index].totalPlan;
        variedades[index].porcentaje = cantidad;
        setVariedades([...variedades]);
    }

    return (
        <div className="w-full p-3 right-0">
            <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <HeadRegresar titulo={"Porcentajes de Variedades y Colores de " + flor} history={props.history} />
                </div>
                <div className="p-5 rounded-b">
                    {/* ---- CONTENIDO --- */}
                    <div className="grid grid-cols-5 gap-1">
                        <div className="p-2 m-1">
                            <form>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    {/** seleccionar el año */}
                                    <div className="w-full mb-3 mr-1 md:mb-0">
                                        <div className="relative">
                                            <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    name="semana"
                                                    value={semana.semana}
                                                    onChange={onChange}>
                                                <option value="0">Ninguna</option>
                                                {
                                                    [...Array(52)].map((y, i) => {
                                                        return (
                                                            <option key={i} value={i + 1}>Samana { i + 1 }</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20">
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="p-2 m-1">

                        </div>
                        <div className="p-2 m-1">
                        </div>
                    </div>
                    {/* Porcentajes de Variedades y Colores */}
                    <div className="grid grid-cols-2 gap-1">
                        <div className="p-2 m-1 rounded-lg shadow-xl border border-orange-100">
                            {/* variedades */}
                            <h3 className="mx-1 my-1 font-bold text-orange-900 mt-3">VARIEDADES - No. Semana: {semana.semana > 0 ? semana.semana:'(No Seleccionada)' }</h3>
                            <table>
                                <thead>
                                    <tr className="bg-orange-900 text-white">
                                        <th className="text-center border border-orange-900 px-2 py-1">Variedad</th>
                                        <th className="text-center border border-orange-900 px-2 py-1">Total</th>
                                        <th className="text-center border border-orange-900 px-2 py-1">%</th>
                                        <th className="text-center border border-orange-900 px-2 py-1">Cantidad</th>
                                        <th className="text-center border border-orange-900 px-2 py-1">
                                            Acciones
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    variedades.map((v,i) => {
                                        return  (
                                            <tr key={i}>
                                                <td className="border px-2 py-1">{ v.nombre }</td>
                                                <td className="border text-right text-sm px-2 py-1">{ v.totalPlan }</td>
                                                <td className="border text-right text-sm px-2 py-1">
                                                    <CantPorVariedad cantidad={v.porcentaje} s={semana.semana} v={v} fn={updateVariedad} index={i} />
                                                </td>
                                                <td className="border text-right text-sm px-2 py-1">{ v.cantidadFlor }</td>
                                                <td className="border text-center text-sm px-2 py-1">
                                                    <button
                                                        className="text-xs bg-blue-700 hover:bg-blue-600 text-white py-1 px-1 my-1 ml-2 rounded shadow focus:outline-none"
                                                        onClick={() => { getColores(v);}}>
                                                        Ver Colores
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                        <div className="p-2 m-1 rounded-lg shadow-xl border border-orange-100">
                            <h3 className="mx-1 my-1 font-bold text-orange-900 mt-3">COLORES DE {variedad}</h3>
                            <table>
                                <thead>
                                <tr className="bg-orange-900 text-white">
                                    <th className="text-center border border-orange-900 px-2 py-1">Color</th>
                                    <th className="text-center border border-orange-900 px-2 py-1">Total</th>
                                    <th className="text-center border border-orange-900 px-2 py-1">%</th>
                                    <th className="text-center border border-orange-900 px-2 py-1">Cantidad</th>

                                </tr>
                                </thead>
                                <tbody>
                                {
                                    colores.map((c,j) => {
                                        return (
                                            <tr key={j}>
                                                <td className="border px-2 py-1">{ c.color }</td>
                                                <td className="border text-right text-sm px-2 py-1">{ c.totalVariedad }</td>
                                                <td className="border text-right text-sm px-2 py-1">
                                                    <CantPorColor cantidad={c.porcentaje} porId={c.porId} />
                                                </td>
                                                <td className="border text-right text-sm px-2 py-1">{ c.cantidadColor }</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            { loader &&
                <MyLoader />
            }
            {/* toaster */}
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>
        </div>
    );
}

export default PorcentajesPlan;
